import SchedulingStrategyToken from '@apps/campaigns/admin/tokens/scheduling_strategy'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Schedule extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Scheduling)', type: 'segment', fields: [
              { name: 'scheduling_strategy', type: 'radiogroup', options: ['later','schedule','now'], format: SchedulingStrategyToken, defaultValue: 'later', required: true },
              { show: config.scheduling_strategy === 'schedule', type: 'fields', fields: [
                { label: 't(Date)', name: 'date', type: 'datefield', defaultValue: config.date, required: true },
                { label: 't(Time)', name: 'time', type: 'timefield', defaultValue: config.time, required: true }
              ] }  
            ] }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(social_campaign) {
    this.props.onSave(social_campaign)
  }

}

export default Schedule
